/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProgramGroupReference
 */
export interface ProgramGroupReference {
    /**
     * 
     * @type {string}
     * @memberof ProgramGroupReference
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramGroupReference
     */
    name?: string;
}

/**
 * Check if a given object implements the ProgramGroupReference interface.
 */
export function instanceOfProgramGroupReference(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProgramGroupReferenceFromJSON(json: any): ProgramGroupReference {
    return ProgramGroupReferenceFromJSONTyped(json, false);
}

export function ProgramGroupReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramGroupReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function ProgramGroupReferenceToJSON(value?: ProgramGroupReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

